import {
  Semanticpmpmvt7fldq2 as Semantic,
  ListSemantic_getInstance2e62q1se6gw64 as ListSemantic_getInstance,
  ImportantSemantic_getInstancehm7lt56tp87l as ImportantSemantic_getInstance,
  override1oesdgz72e8ey as override,
  WarningSemantic_getInstance3kp0xfef7wnw4 as WarningSemantic_getInstance,
  _SemanticOverrides___init__impl__g2p3k812zbkczmal1zf as _SemanticOverrides___init__impl__g2p3k8,
  AffirmativeSemantic_getInstance2svzxainpava5 as AffirmativeSemantic_getInstance,
  DangerSemantic_getInstance1xd9zwrvs99lp as DangerSemantic_getInstance,
  SubtextSemantic_getInstance1duu1ll1kgx8d as SubtextSemantic_getInstance,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import {
  get_dp28ag147e4p5cz as get_dp,
  get_rem14pbkv8p42gid as get_rem,
  get_px8ok5q0jdway2 as get_px,
  get_systemDefaultFixedWidthFont14cv3wy0prdkq as get_systemDefaultFixedWidthFont,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  Edges2jf5wl855ambv as Edges,
  Companion_getInstance252uiobns9yoh as Companion_getInstance,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Rect.mjs';
import {
  PerCorner27xb33zgvi5gv as PerCorner,
  Fixed1p8lc8swyflir as Fixed,
  CornerRadii1b82t7ytilhrv as CornerRadii,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/CornerRadii.mjs';
import { StyleTokens_getInstance3r0ikbe1r8w63 as StyleTokens_getInstance } from './theme.mjs';
import { Companion_getInstance2u620q9r4ejbj as Companion_getInstance_0 } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Paint.mjs';
import { themed2vu67ornd4jps as themed } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  TextView$_get_content_$ref_4pzcwl5a4gnldk8ef9 as TextView$_get_content_$ref_4pzcwl,
  TextView$_set_content_$ref_pketfb11e282hr0m0jl as TextView$_set_content_$ref_pketfb,
} from '../App.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { times2ukvaf6yk96p2 as times } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SmallTextSemanticClass;
function SmallTextSemantic() {
  if (SmallTextSemanticClass === VOID) {
    class $ extends Semantic() {
      constructor() {
        SmallTextSemantic_instance = null;
        super('smtxt');
        SmallTextSemantic_instance = this;
      }
      default_buqihh_k$(theme) {
        return this.withoutBack$default_y4jue9_k$(theme, VOID, theme.font_1.copy$default_cfilcw_k$(VOID, VOID, VOID, VOID, VOID, VOID, get_dp(13)));
      }
      toString() {
        return 'SmallTextSemantic';
      }
      hashCode() {
        return -71650180;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SmallTextSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'SmallTextSemantic');
    SmallTextSemanticClass = $;
  }
  return SmallTextSemanticClass;
}
var SmallTextSemantic_instance;
function SmallTextSemantic_getInstance() {
  if (SmallTextSemantic_instance === VOID)
    new (SmallTextSemantic())();
  return SmallTextSemantic_instance;
}
var LargeTextSemanticClass;
function LargeTextSemantic() {
  if (LargeTextSemanticClass === VOID) {
    class $ extends Semantic() {
      constructor() {
        LargeTextSemantic_instance = null;
        super('lgtxt');
        LargeTextSemantic_instance = this;
      }
      default_buqihh_k$(theme) {
        return this.withoutBack$default_y4jue9_k$(theme, VOID, theme.font_1.copy$default_cfilcw_k$(VOID, VOID, VOID, VOID, VOID, VOID, get_dp(18)));
      }
      toString() {
        return 'LargeTextSemantic';
      }
      hashCode() {
        return 1021783216;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof LargeTextSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'LargeTextSemantic');
    LargeTextSemanticClass = $;
  }
  return LargeTextSemanticClass;
}
var LargeTextSemantic_instance;
function LargeTextSemantic_getInstance() {
  if (LargeTextSemantic_instance === VOID)
    new (LargeTextSemantic())();
  return LargeTextSemantic_instance;
}
var TableSemanticClass;
function TableSemantic() {
  if (TableSemanticClass === VOID) {
    class $ extends Semantic() {
      constructor() {
        TableSemantic_instance = null;
        super('table');
        TableSemantic_instance = this;
      }
      default_buqihh_k$(theme) {
        return this.alter$default_u3pj3s_k$(theme, VOID, VOID, VOID, VOID, VOID, get_rem(0.45), Edges().new_com_lightningkite_kiteui_models_Edges_h2jw3i_k$(get_rem(0.45))).get_6y9l0r_k$(ListSemantic_getInstance());
      }
      toString() {
        return 'TableSemantic';
      }
      hashCode() {
        return -18606986;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof TableSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'TableSemantic');
    TableSemanticClass = $;
  }
  return TableSemanticClass;
}
var TableSemantic_instance;
function TableSemantic_getInstance() {
  if (TableSemantic_instance === VOID)
    new (TableSemantic())();
  return TableSemantic_instance;
}
var TableHeaderSemanticClass;
function TableHeaderSemantic() {
  if (TableHeaderSemanticClass === VOID) {
    class $ extends Semantic() {
      constructor() {
        TableHeaderSemantic_instance = null;
        super('table-header');
        TableHeaderSemantic_instance = this;
      }
      default_buqihh_k$(theme) {
        var tmp0_cornerRadii = new (PerCorner())(get_dp(8), true, true);
        var tmp1_font = theme.font_1.copy$default_cfilcw_k$(VOID, VOID, VOID, true, VOID, get_rem(0.03), get_dp(12));
        return this.withBack$default_t8expd_k$(theme, VOID, tmp1_font, VOID, tmp0_cornerRadii);
      }
      toString() {
        return 'TableHeaderSemantic';
      }
      hashCode() {
        return -849954269;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof TableHeaderSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'TableHeaderSemantic');
    TableHeaderSemanticClass = $;
  }
  return TableHeaderSemanticClass;
}
var TableHeaderSemantic_instance;
function TableHeaderSemantic_getInstance() {
  if (TableHeaderSemantic_instance === VOID)
    new (TableHeaderSemantic())();
  return TableHeaderSemantic_instance;
}
var TableHeaderLeftSemanticClass;
function TableHeaderLeftSemantic() {
  if (TableHeaderLeftSemanticClass === VOID) {
    class $ extends Semantic() {
      constructor() {
        TableHeaderLeftSemantic_instance = null;
        super('table-header-l');
        TableHeaderLeftSemantic_instance = this;
      }
      default_buqihh_k$(theme) {
        var tmp0_cornerRadii = new (PerCorner())(get_dp(8), true);
        var tmp1_font = theme.font_1.copy$default_cfilcw_k$(VOID, VOID, VOID, true, VOID, get_rem(0.03), get_dp(12));
        return this.withBack$default_t8expd_k$(theme, VOID, tmp1_font, VOID, tmp0_cornerRadii);
      }
      toString() {
        return 'TableHeaderLeftSemantic';
      }
      hashCode() {
        return -2026155830;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof TableHeaderLeftSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'TableHeaderLeftSemantic');
    TableHeaderLeftSemanticClass = $;
  }
  return TableHeaderLeftSemanticClass;
}
var TableHeaderLeftSemantic_instance;
function TableHeaderLeftSemantic_getInstance() {
  if (TableHeaderLeftSemantic_instance === VOID)
    new (TableHeaderLeftSemantic())();
  return TableHeaderLeftSemantic_instance;
}
var TableHeaderRightSemanticClass;
function TableHeaderRightSemantic() {
  if (TableHeaderRightSemanticClass === VOID) {
    class $ extends Semantic() {
      constructor() {
        TableHeaderRightSemantic_instance = null;
        super('table-header-r');
        TableHeaderRightSemantic_instance = this;
      }
      default_buqihh_k$(theme) {
        var tmp0_cornerRadii = new (PerCorner())(get_dp(8), VOID, true);
        var tmp1_font = theme.font_1.copy$default_cfilcw_k$(VOID, VOID, VOID, true, VOID, get_rem(0.03), get_dp(12));
        return this.withBack$default_t8expd_k$(theme, VOID, tmp1_font, VOID, tmp0_cornerRadii);
      }
      toString() {
        return 'TableHeaderRightSemantic';
      }
      hashCode() {
        return 1929813445;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof TableHeaderRightSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'TableHeaderRightSemantic');
    TableHeaderRightSemanticClass = $;
  }
  return TableHeaderRightSemanticClass;
}
var TableHeaderRightSemantic_instance;
function TableHeaderRightSemantic_getInstance() {
  if (TableHeaderRightSemantic_instance === VOID)
    new (TableHeaderRightSemantic())();
  return TableHeaderRightSemantic_instance;
}
var TableFooterLeftSemanticClass;
function TableFooterLeftSemantic() {
  if (TableFooterLeftSemanticClass === VOID) {
    class $ extends Semantic() {
      constructor() {
        TableFooterLeftSemantic_instance = null;
        super('table-footer-l');
        TableFooterLeftSemantic_instance = this;
      }
      default_buqihh_k$(theme) {
        var tmp0_cornerRadii = new (PerCorner())(get_dp(8), VOID, VOID, true);
        var tmp1_font = theme.font_1.copy$default_cfilcw_k$(VOID, VOID, VOID, true, VOID, get_rem(0.03), get_dp(12));
        return this.withBack$default_t8expd_k$(theme, VOID, tmp1_font, VOID, tmp0_cornerRadii);
      }
      toString() {
        return 'TableFooterLeftSemantic';
      }
      hashCode() {
        return 409665240;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof TableFooterLeftSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'TableFooterLeftSemantic');
    TableFooterLeftSemanticClass = $;
  }
  return TableFooterLeftSemanticClass;
}
var TableFooterLeftSemantic_instance;
function TableFooterLeftSemantic_getInstance() {
  if (TableFooterLeftSemantic_instance === VOID)
    new (TableFooterLeftSemantic())();
  return TableFooterLeftSemantic_instance;
}
var TableFooterRightSemanticClass;
function TableFooterRightSemantic() {
  if (TableFooterRightSemanticClass === VOID) {
    class $ extends Semantic() {
      constructor() {
        TableFooterRightSemantic_instance = null;
        super('table-footer-r');
        TableFooterRightSemantic_instance = this;
      }
      default_buqihh_k$(theme) {
        var tmp0_cornerRadii = new (PerCorner())(get_dp(8), VOID, VOID, VOID, true);
        var tmp1_font = theme.font_1.copy$default_cfilcw_k$(VOID, VOID, VOID, true, VOID, get_rem(0.03), get_dp(12));
        return this.withBack$default_t8expd_k$(theme, VOID, tmp1_font, VOID, tmp0_cornerRadii);
      }
      toString() {
        return 'TableFooterRightSemantic';
      }
      hashCode() {
        return 130855287;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof TableFooterRightSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'TableFooterRightSemantic');
    TableFooterRightSemanticClass = $;
  }
  return TableFooterRightSemanticClass;
}
var TableFooterRightSemantic_instance;
function TableFooterRightSemantic_getInstance() {
  if (TableFooterRightSemantic_instance === VOID)
    new (TableFooterRightSemantic())();
  return TableFooterRightSemantic_instance;
}
var TableRowSemanticClass;
function TableRowSemantic() {
  if (TableRowSemanticClass === VOID) {
    class $ extends Semantic() {
      constructor() {
        TableRowSemantic_instance = null;
        super('table-row');
        TableRowSemantic_instance = this;
      }
      default_buqihh_k$(theme) {
        var tmp0_background = StyleTokens_getInstance().surface_1;
        var tmp1_cornerRadii = new (Fixed())(get_px(0));
        return this.withBack$default_t8expd_k$(theme, false, VOID, VOID, tmp1_cornerRadii, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp0_background);
      }
      toString() {
        return 'TableRowSemantic';
      }
      hashCode() {
        return 432712976;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof TableRowSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'TableRowSemantic');
    TableRowSemanticClass = $;
  }
  return TableRowSemanticClass;
}
var TableRowSemantic_instance;
function TableRowSemantic_getInstance() {
  if (TableRowSemantic_instance === VOID)
    new (TableRowSemantic())();
  return TableRowSemantic_instance;
}
var TableCellSemanticClass;
function TableCellSemantic() {
  if (TableCellSemanticClass === VOID) {
    class $ extends Semantic() {
      constructor() {
        TableCellSemantic_instance = null;
        super('table-cell');
        TableCellSemantic_instance = this;
      }
      default_buqihh_k$(theme) {
        return this.withoutBack$default_y4jue9_k$(theme);
      }
      toString() {
        return 'TableCellSemantic';
      }
      hashCode() {
        return -176969736;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof TableCellSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'TableCellSemantic');
    TableCellSemanticClass = $;
  }
  return TableCellSemanticClass;
}
var TableCellSemantic_instance;
function TableCellSemantic_getInstance() {
  if (TableCellSemantic_instance === VOID)
    new (TableCellSemantic())();
  return TableCellSemantic_instance;
}
var IconButtonSemanticClass;
function IconButtonSemantic() {
  if (IconButtonSemanticClass === VOID) {
    class $ extends Semantic() {
      constructor() {
        IconButtonSemantic_instance = null;
        super('icon-btn');
        IconButtonSemantic_instance = this;
      }
      default_buqihh_k$(theme) {
        return this.withBack$default_t8expd_k$(theme);
      }
      toString() {
        return 'IconButtonSemantic';
      }
      hashCode() {
        return 2110774383;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof IconButtonSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'IconButtonSemantic');
    IconButtonSemanticClass = $;
  }
  return IconButtonSemanticClass;
}
var IconButtonSemantic_instance;
function IconButtonSemantic_getInstance() {
  if (IconButtonSemantic_instance === VOID)
    new (IconButtonSemantic())();
  return IconButtonSemantic_instance;
}
var ShadedSemanticClass;
function ShadedSemantic() {
  if (ShadedSemanticClass === VOID) {
    class $ extends Semantic() {
      constructor() {
        ShadedSemantic_instance = null;
        super('shaded');
        ShadedSemantic_instance = this;
      }
      default_buqihh_k$(theme) {
        return this.withBack$default_t8expd_k$(theme, false, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, StyleTokens_getInstance().appBackground_1);
      }
      toString() {
        return 'ShadedSemantic';
      }
      hashCode() {
        return -909941189;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ShadedSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'ShadedSemantic');
    ShadedSemanticClass = $;
  }
  return ShadedSemanticClass;
}
var ShadedSemantic_instance;
function ShadedSemantic_getInstance() {
  if (ShadedSemantic_instance === VOID)
    new (ShadedSemantic())();
  return ShadedSemantic_instance;
}
function BannerSemantic$default$lambda($this$override, it) {
  var tmp0_background = Companion_getInstance_0().fromHexString_vb3go_k$('#eaf1fb');
  var tmp1_foreground = Companion_getInstance_0().fromHexString_vb3go_k$('#133f78');
  var tmp2_outline = Companion_getInstance_0().fromHexString_vb3go_k$('#c4d8f2');
  return $this$override.withBack$default_t8expd_k$(it, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp1_foreground, VOID, tmp2_outline, VOID, VOID, tmp0_background);
}
function BannerSemantic$default$lambda_0($this$override, it) {
  var tmp0_background = Companion_getInstance_0().fromHexString_vb3go_k$('#fff3dd');
  var tmp1_foreground = Companion_getInstance_0().fromHexString_vb3go_k$('#8a5900');
  var tmp2_outline = Companion_getInstance_0().fromHexString_vb3go_k$('#f0d59a');
  return $this$override.withBack$default_t8expd_k$(it, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp1_foreground, VOID, tmp2_outline, VOID, VOID, tmp0_background);
}
var BannerSemanticClass;
function BannerSemantic() {
  if (BannerSemanticClass === VOID) {
    class $ extends Semantic() {
      constructor() {
        BannerSemantic_instance = null;
        super('banner');
        BannerSemantic_instance = this;
      }
      default_buqihh_k$(theme) {
        var tmp = get_dp(1);
        var tmp_0 = ImportantSemantic_getInstance();
        var tmp_1 = override(tmp_0, BannerSemantic$default$lambda);
        var tmp_2 = WarningSemantic_getInstance();
        return this.withBack$default_t8expd_k$(theme, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp, VOID, VOID, VOID, VOID, VOID, VOID, VOID, _SemanticOverrides___init__impl__g2p3k8([tmp_1, override(tmp_2, BannerSemantic$default$lambda_0)]));
      }
      toString() {
        return 'BannerSemantic';
      }
      hashCode() {
        return -1792653168;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof BannerSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'BannerSemantic');
    BannerSemanticClass = $;
  }
  return BannerSemanticClass;
}
var BannerSemantic_instance;
function BannerSemantic_getInstance() {
  if (BannerSemantic_instance === VOID)
    new (BannerSemantic())();
  return BannerSemantic_instance;
}
var StyledHeaderClass;
function StyledHeader() {
  if (StyledHeaderClass === VOID) {
    class $ extends Semantic() {
      constructor() {
        StyledHeader_instance = null;
        super('styled-hdr');
        StyledHeader_instance = this;
      }
      default_buqihh_k$(theme) {
        var tmp0_$this = theme.font_1;
        var tmp1_size = get_dp(12);
        var tmp2_additionalLetterSpacing = get_rem(0.02);
        return this.withoutBack$default_y4jue9_k$(theme, VOID, tmp0_$this.copy$default_cfilcw_k$(VOID, VOID, 500, VOID, VOID, tmp2_additionalLetterSpacing, tmp1_size), VOID, VOID, VOID, VOID, VOID, Companion_getInstance_0().fromHexString_vb3go_k$('#647080'));
      }
      toString() {
        return 'StyledHeader';
      }
      hashCode() {
        return -1404245954;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof StyledHeader()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'StyledHeader');
    StyledHeaderClass = $;
  }
  return StyledHeaderClass;
}
var StyledHeader_instance;
function StyledHeader_getInstance() {
  if (StyledHeader_instance === VOID)
    new (StyledHeader())();
  return StyledHeader_instance;
}
function styledHeader(_this__u8e3s4, text) {
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  var this_0 = themed(_this__u8e3s4, StyledHeader_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (TextView())(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element);
  this_0.willAddChild_hz2iwc_k$(element);
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
  var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
  element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => {
    // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
    // Inline function 'kotlin.text.uppercase' call
    // Inline function 'kotlin.js.asDynamic' call
    return text($this$invoke).toUpperCase();
  });
  element.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element);
  return element;
}
var CodeTextSemanticClass;
function CodeTextSemantic() {
  if (CodeTextSemanticClass === VOID) {
    class $ extends Semantic() {
      constructor() {
        CodeTextSemantic_instance = null;
        super('code-text');
        CodeTextSemantic_instance = this;
      }
      default_buqihh_k$(theme) {
        return this.withoutBack$default_y4jue9_k$(theme, VOID, theme.font_1.copy$default_cfilcw_k$(get_systemDefaultFixedWidthFont()));
      }
      toString() {
        return 'CodeTextSemantic';
      }
      hashCode() {
        return -1422517090;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof CodeTextSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'CodeTextSemantic');
    CodeTextSemanticClass = $;
  }
  return CodeTextSemanticClass;
}
var CodeTextSemantic_instance;
function CodeTextSemantic_getInstance() {
  if (CodeTextSemantic_instance === VOID)
    new (CodeTextSemantic())();
  return CodeTextSemantic_instance;
}
function ChipSemantic$default$lambda($this$override, it) {
  var tmp0_background = Companion_getInstance_0().fromHexString_vb3go_k$('#e7f5ee');
  var tmp1_foreground = StyleTokens_getInstance().success_1;
  var tmp2_outline = Companion_getInstance_0().fromHexString_vb3go_k$('#b9e2cc');
  return $this$override.withBack$default_t8expd_k$(it, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp1_foreground, VOID, tmp2_outline, VOID, VOID, tmp0_background);
}
function ChipSemantic$default$lambda_0($this$override, it) {
  var tmp0_background = Companion_getInstance_0().fromHexString_vb3go_k$('#fceceb');
  var tmp1_foreground = StyleTokens_getInstance().danger_1;
  var tmp2_outline = Companion_getInstance_0().fromHexString_vb3go_k$('#f0c3bd');
  return $this$override.withBack$default_t8expd_k$(it, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp1_foreground, VOID, tmp2_outline, VOID, VOID, tmp0_background);
}
function ChipSemantic$default$lambda_1($this$override, it) {
  var tmp0_background = Companion_getInstance_0().fromHexString_vb3go_k$('#fff3dd');
  var tmp1_foreground = Companion_getInstance_0().fromHexString_vb3go_k$('#8a5900');
  var tmp2_outline = Companion_getInstance_0().fromHexString_vb3go_k$('#f0d59a');
  return $this$override.withBack$default_t8expd_k$(it, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp1_foreground, VOID, tmp2_outline, VOID, VOID, tmp0_background);
}
var ChipSemanticClass;
function ChipSemantic() {
  if (ChipSemanticClass === VOID) {
    class $ extends Semantic() {
      constructor() {
        ChipSemantic_instance = null;
        super('chip');
        ChipSemantic_instance = this;
      }
      default_buqihh_k$(theme) {
        var tmp3_cornerRadii = new (Fixed())(get_dp(20));
        var tmp4_padding = Edges().new_com_lightningkite_kiteui_models_Edges_1f8j9i_k$(get_rem(0.55), get_rem(0.24));
        var tmp0_$this = theme.font_1;
        var tmp1_size = get_dp(12);
        var tmp2_additionalLetterSpacing = get_rem(0.02);
        var tmp5_font = tmp0_$this.copy$default_cfilcw_k$(VOID, VOID, VOID, VOID, VOID, tmp2_additionalLetterSpacing, tmp1_size);
        var tmp6_outlineWidth = get_dp(1);
        var tmp = AffirmativeSemantic_getInstance();
        var tmp_0 = override(tmp, ChipSemantic$default$lambda);
        var tmp_1 = DangerSemantic_getInstance();
        var tmp_2 = override(tmp_1, ChipSemantic$default$lambda_0);
        var tmp_3 = WarningSemantic_getInstance();
        var tmp7_semanticOverrides = _SemanticOverrides___init__impl__g2p3k8([tmp_0, tmp_2, override(tmp_3, ChipSemantic$default$lambda_1)]);
        return this.withBack$default_t8expd_k$(theme, VOID, tmp5_font, VOID, tmp3_cornerRadii, VOID, VOID, tmp4_padding, VOID, VOID, VOID, tmp6_outlineWidth, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp7_semanticOverrides);
      }
      toString() {
        return 'ChipSemantic';
      }
      hashCode() {
        return 1761019184;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ChipSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'ChipSemantic');
    ChipSemanticClass = $;
  }
  return ChipSemanticClass;
}
var ChipSemantic_instance;
function ChipSemantic_getInstance() {
  if (ChipSemantic_instance === VOID)
    new (ChipSemantic())();
  return ChipSemantic_instance;
}
var SpaciousSemanticClass;
function SpaciousSemantic() {
  if (SpaciousSemanticClass === VOID) {
    class $ extends Semantic() {
      constructor() {
        SpaciousSemantic_instance = null;
        super('spacious');
        SpaciousSemantic_instance = this;
      }
      default_buqihh_k$(theme) {
        var tmp0_gap = times(theme.gap_1, 2);
        var tmp1_padding = theme.padding_1.times_kr2a3y_k$(2);
        return this.withoutBack$default_y4jue9_k$(theme, false, VOID, VOID, VOID, VOID, tmp0_gap, tmp1_padding);
      }
      toString() {
        return 'SpaciousSemantic';
      }
      hashCode() {
        return -1661942553;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SpaciousSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'SpaciousSemantic');
    SpaciousSemanticClass = $;
  }
  return SpaciousSemanticClass;
}
var SpaciousSemantic_instance;
function SpaciousSemantic_getInstance() {
  if (SpaciousSemantic_instance === VOID)
    new (SpaciousSemantic())();
  return SpaciousSemantic_instance;
}
var DangerTextSemanticClass;
function DangerTextSemantic() {
  if (DangerTextSemanticClass === VOID) {
    class $ extends Semantic() {
      constructor() {
        DangerTextSemantic_instance = null;
        super('dngr-txt');
        DangerTextSemantic_instance = this;
      }
      default_buqihh_k$(theme) {
        return this.withoutBack$default_y4jue9_k$(theme, VOID, VOID, VOID, VOID, VOID, VOID, VOID, StyleTokens_getInstance().danger_1);
      }
      toString() {
        return 'DangerTextSemantic';
      }
      hashCode() {
        return 628022356;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DangerTextSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'DangerTextSemantic');
    DangerTextSemanticClass = $;
  }
  return DangerTextSemanticClass;
}
var DangerTextSemantic_instance;
function DangerTextSemantic_getInstance() {
  if (DangerTextSemantic_instance === VOID)
    new (DangerTextSemantic())();
  return DangerTextSemantic_instance;
}
var SidePanelSemanticClass;
function SidePanelSemantic() {
  if (SidePanelSemanticClass === VOID) {
    class $ extends Semantic() {
      constructor() {
        SidePanelSemantic_instance = null;
        super('side-pnl');
        SidePanelSemantic_instance = this;
      }
      default_buqihh_k$(theme) {
        return this.withBack$default_t8expd_k$(theme, false, VOID, VOID, new (Fixed())(get_dp(0)));
      }
      toString() {
        return 'SidePanelSemantic';
      }
      hashCode() {
        return 471405461;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SidePanelSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'SidePanelSemantic');
    SidePanelSemanticClass = $;
  }
  return SidePanelSemanticClass;
}
var SidePanelSemantic_instance;
function SidePanelSemantic_getInstance() {
  if (SidePanelSemantic_instance === VOID)
    new (SidePanelSemantic())();
  return SidePanelSemantic_instance;
}
var NumberBadgeSemanticClass;
function NumberBadgeSemantic() {
  if (NumberBadgeSemanticClass === VOID) {
    class $ extends Semantic() {
      constructor() {
        NumberBadgeSemantic_instance = null;
        super('nmbrbdg');
        NumberBadgeSemantic_instance = this;
      }
      default_buqihh_k$(theme) {
        var tmp2_background = StyleTokens_getInstance().primary_1;
        var tmp3_foreground = Companion_getInstance_0().white_1;
        var tmp4_cornerRadii = CornerRadii(get_rem(0.6));
        var tmp5_padding = Edges().new_com_lightningkite_kiteui_models_Edges_1f8j9i_k$(get_rem(0.25), get_px(0));
        var tmp0_$this = theme.font_1;
        var tmp1_size = get_rem(0.55);
        var tmp6_font = tmp0_$this.copy$default_cfilcw_k$(VOID, VOID, 700, VOID, VOID, VOID, tmp1_size);
        var tmp7_outlineWidth = get_dp(0);
        return this.withBack$default_t8expd_k$(theme, false, tmp6_font, VOID, tmp4_cornerRadii, VOID, VOID, tmp5_padding, tmp3_foreground, VOID, VOID, tmp7_outlineWidth, VOID, tmp2_background);
      }
    }
    initMetadataForObject($, 'NumberBadgeSemantic');
    NumberBadgeSemanticClass = $;
  }
  return NumberBadgeSemanticClass;
}
var NumberBadgeSemantic_instance;
function NumberBadgeSemantic_getInstance() {
  if (NumberBadgeSemantic_instance === VOID)
    new (NumberBadgeSemantic())();
  return NumberBadgeSemantic_instance;
}
var LinkSemanticClass;
function LinkSemantic() {
  if (LinkSemanticClass === VOID) {
    class $ extends Semantic() {
      constructor() {
        LinkSemantic_instance = null;
        super('link');
        LinkSemantic_instance = this;
      }
      default_buqihh_k$(theme) {
        var tmp0_foreground = StyleTokens_getInstance().primary_1;
        var tmp1_font = theme.font_1.copy$default_cfilcw_k$(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, true);
        var tmp2_padding = Companion_getInstance().ZERO_1;
        return this.withoutBack$default_y4jue9_k$(theme, VOID, tmp1_font, VOID, VOID, VOID, VOID, tmp2_padding, tmp0_foreground);
      }
      toString() {
        return 'LinkSemantic';
      }
      hashCode() {
        return 590582494;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof LinkSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'LinkSemantic');
    LinkSemanticClass = $;
  }
  return LinkSemanticClass;
}
var LinkSemantic_instance;
function LinkSemantic_getInstance() {
  if (LinkSemantic_instance === VOID)
    new (LinkSemantic())();
  return LinkSemantic_instance;
}
var TextOnlyButtonSemanticClass;
function TextOnlyButtonSemantic() {
  if (TextOnlyButtonSemanticClass === VOID) {
    class $ extends Semantic() {
      constructor() {
        TextOnlyButtonSemantic_instance = null;
        super('txtbtn');
        TextOnlyButtonSemantic_instance = this;
      }
      default_buqihh_k$(theme) {
        var tmp0_foreground = StyleTokens_getInstance().primary_1;
        var tmp1_padding = Companion_getInstance().ZERO_1;
        return this.withoutBack$default_y4jue9_k$(theme, VOID, VOID, VOID, VOID, VOID, VOID, tmp1_padding, tmp0_foreground);
      }
      toString() {
        return 'TextOnlyButtonSemantic';
      }
      hashCode() {
        return 1700473711;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof TextOnlyButtonSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'TextOnlyButtonSemantic');
    TextOnlyButtonSemanticClass = $;
  }
  return TextOnlyButtonSemanticClass;
}
var TextOnlyButtonSemantic_instance;
function TextOnlyButtonSemantic_getInstance() {
  if (TextOnlyButtonSemantic_instance === VOID)
    new (TextOnlyButtonSemantic())();
  return TextOnlyButtonSemantic_instance;
}
var UnreadNotificationSemanticClass;
function UnreadNotificationSemantic() {
  if (UnreadNotificationSemanticClass === VOID) {
    class $ extends Semantic() {
      constructor() {
        UnreadNotificationSemantic_instance = null;
        super('unreadnotif');
        UnreadNotificationSemantic_instance = this;
      }
      default_buqihh_k$(theme) {
        var tmp0_background = Companion_getInstance_0().fromHexString_vb3go_k$('#EAF1FB');
        var tmp1_iconOverride = StyleTokens_getInstance().primary_1;
        var tmp = SubtextSemantic_getInstance();
        var tmp2_semanticOverrides = _SemanticOverrides___init__impl__g2p3k8([override(tmp, ($this$override, it) => $this$override.withoutBack$default_y4jue9_k$(it, VOID, theme.font_1.copy$default_cfilcw_k$(VOID, VOID, VOID, VOID, VOID, VOID, get_rem(0.8)), VOID, VOID, VOID, VOID, VOID, StyleTokens_getInstance().primary_1))]);
        return this.withBack$default_t8expd_k$(theme, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp1_iconOverride, VOID, VOID, VOID, tmp0_background, VOID, VOID, VOID, VOID, VOID, tmp2_semanticOverrides);
      }
      toString() {
        return 'UnreadNotificationSemantic';
      }
      hashCode() {
        return 1167708318;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof UnreadNotificationSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'UnreadNotificationSemantic');
    UnreadNotificationSemanticClass = $;
  }
  return UnreadNotificationSemanticClass;
}
var UnreadNotificationSemantic_instance;
function UnreadNotificationSemantic_getInstance() {
  if (UnreadNotificationSemantic_instance === VOID)
    new (UnreadNotificationSemantic())();
  return UnreadNotificationSemantic_instance;
}
//region block: exports
export {
  BannerSemantic_getInstance as BannerSemantic_getInstance18p0b4btg61q8,
  ChipSemantic_getInstance as ChipSemantic_getInstancen74y1gyt9zmo,
  CodeTextSemantic_getInstance as CodeTextSemantic_getInstance26ilcf3y0fab5,
  DangerTextSemantic_getInstance as DangerTextSemantic_getInstancetznd91yayzn7,
  IconButtonSemantic_getInstance as IconButtonSemantic_getInstanceyhbmf43a1vw3,
  LargeTextSemantic_getInstance as LargeTextSemantic_getInstance3ukb2tgj992rz,
  LinkSemantic_getInstance as LinkSemantic_getInstance292trrvb33tue,
  NumberBadgeSemantic_getInstance as NumberBadgeSemantic_getInstance2wez41hmadmon,
  ShadedSemantic_getInstance as ShadedSemantic_getInstance1fiswfajryzey,
  SidePanelSemantic_getInstance as SidePanelSemantic_getInstance2ldeh6wpizc8,
  SmallTextSemantic_getInstance as SmallTextSemantic_getInstance3ht14r7yzc9rl,
  SpaciousSemantic_getInstance as SpaciousSemantic_getInstance49m8xgr9xadn,
  TableCellSemantic_getInstance as TableCellSemantic_getInstancej0y7idum3jgg,
  TableFooterLeftSemantic_getInstance as TableFooterLeftSemantic_getInstance1b61o9gvheh34,
  TableFooterRightSemantic_getInstance as TableFooterRightSemantic_getInstance2ukhshj89nvz4,
  TableHeaderLeftSemantic_getInstance as TableHeaderLeftSemantic_getInstance1e4eceqp04ppd,
  TableHeaderRightSemantic_getInstance as TableHeaderRightSemantic_getInstance1159xojxgn34t,
  TableHeaderSemantic_getInstance as TableHeaderSemantic_getInstanceqomb25yoya3n,
  TableRowSemantic_getInstance as TableRowSemantic_getInstance396gywh21vbqh,
  TableSemantic_getInstance as TableSemantic_getInstance3cbunlgg7bvuu,
  TextOnlyButtonSemantic_getInstance as TextOnlyButtonSemantic_getInstance26zmm1m4hs065,
  UnreadNotificationSemantic_getInstance as UnreadNotificationSemantic_getInstance2xhggpn2jfpdt,
  styledHeader as styledHeaderwng1nfqibdig,
};
//endregion

//# sourceMappingURL=semantics.mjs.map
